<template>
  <div>
    <div class>
      <Steps :active="3" align-center>
        <Step :title="$t('course.csbase')" @click.native="on_click('csbase')" />
        <Step :title="$t('course.cscondition')" @click.native="on_click('cscondition')" />
        <Step :title="$t('course.csprice')" @click.native="on_click('csprice')" />
        <Step :title="$t('course.csrpt')"  />
        <Step :title="$t('course.csinvest')" @click.native="on_click('csinvest')" />
        <Step :title="$t('course.csability')" @click.native="on_click('csability')" />
      </Steps>
    </div>
    <br/>
    <div class='divMessage' style=" word-wrap:break-word; word-break:break-all;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
    <br/>
    <el-card class="aui-card--fill" shadow="never">
      <el-form label-position="top"
          :inline="true"
          :model="dataForm"
          :rules="dataRule"
          label-width="145px"
          ref="dataForm">
        <el-row >
          <el-col :span="6">
                <el-form-item :label="$t('course.countUtilizationFlag')"  prop="countUtilizationFlag" style="display: block">
                <el-select v-model="dataForm.countUtilizationFlag">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('course.quickTestFlag')" prop="quickTestFlag" style="display: block">
              <span slot="label">{{$t('course.quickTestFlag')}}
                <el-tooltip placement="bottom-start" effect="light" >
                  <div slot="content">
                    为避免影响数据统计结果，请选择正确分类。
                  </div>
                  <em class="el-icon-question" style="color: #1C69D3"></em>
                </el-tooltip>
              </span>
              <el-select v-model="dataForm.quickTestFlag" @click="checkSelect($event)">
                <el-option
                        v-for="item in options1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 间隔时长 -->
           <el-col :span="6" v-if="dataForm.quickTestFlag == 10">
            <el-form-item :label="$t('course.intervalTime')" prop="intervalTime" style="display: block">
              <span slot="label">{{$t('course.intervalTime')}}
                <el-tooltip placement="bottom-start" effect="light" >
                  <div slot="content">
                    学员两次报名能力评估课程的间隔需大于N个月
                  </div>
                  <em class="el-icon-question" style="color: #1C69D3"></em>
                </el-tooltip>
              </span>
              <el-input   v-model.number="dataForm.intervalTime" type="text" @keyup.native="number($event)" maxlength="5">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('course.serioustraining')" prop="serioustraining" style="display: block">
                <el-select v-model="dataForm.serioustraining">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div>
       <el-row  style="float:right; margin-bottom: 60px;">
          <el-col :span="16"><div class="grid-content" /></el-col>
          <el-button v-if="$hasPermission('learning:courseinfo:csrptSave') && $hasPermission('learning:courseinfo:csinvestSave')"
                     @click="saveSend"  type="primary">{{ $t("course.saveAndNext") }}</el-button>
          <el-button v-if="$hasPermission('learning:courseinfo:csrptSave')"
                     @click="save"  type="primary">{{ $t("course.save") }}</el-button>
          <ZElButton @click="cancel" >{{ $t("course.cancel") }}</ZElButton>
       </el-row>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
import ZElButton from '../../common/button/index'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: { Steps, Step, ZElButton },
  props: ['message', 'courseid'],
  inject: ['toTop'],
  data () {
    // 这里存放数据
    return {
      courseId: '',
      options1: [{
          value: '20',
          label: '无'
      }, {
        value: '10',
        label: '能力评估'
      }, {
          value: '30',
          label: '随堂认证'
      }, {
          value: '40',
          label: '集中认证'
      }],
      options: [{
            value: '10',
            label: '是'
        }, {
            value: '20',
            label: '否'
        }],
      // inServForm: {
      //   deadLineDays: '2'
      // },
      dataForm: {
        courseId: '',
        countUtilizationFlag: '20',
        quickTestFlag: '20',
        serioustraining: '20',
        intervalTime: ''
      },
      seen: 'false'
    }
  },
  // 监听属性 类似于data概念
  computed: {
    dataRule () {
      return {
        countUtilizationFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        quickTestFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        serioustraining: [
            { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        intervalTime: [
            { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    console.log('created')
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.init()
    this.$eventHub.$on('showCourse', (data) => {
      console.log('showCourse csrpt ')
      this.init()
    })
    this.$eventHub.$on('addCourse', (data) => {
      this.again()
      this.courseId = ''
    })

    this.dataForm.courseId = this.courseid
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    console.log('activated')
  },
  // 方法集合
  methods: {
    //绑定input数据
    // updateView (e)  {
    // this.$forceUpdate()
    // },
     number(e) {
       console.log(e.target.value);
       let  flag = new RegExp("^[1-9]([0-9])*$").test(e.target.value);
       console.log(flag);
       if (!flag) {
         this.dataForm.intervalTime = ''
        }
    },
    // 设置初始化为空
    again () {
      this.dataForm.courseId = ''
      this.dataForm.countUtilizationFlag = '20'
      this.dataForm.quickTestFlag = '20'
      this.dataForm.serioustraining = '20'
    },
    // 初始化数据
    init () {
      this.again()
      this.courseId = this.$route.query.courseId
      if (this.courseId !== undefined) {
        this.$request.get('/learning/courseinfo/getOne/' + this.courseId).then((res, total, code, data) => {
          for (let key in data.data) {
            if (this.dataForm.hasOwnProperty(key)) {
              if (data.data[key] !== null || data.data[key] !== undefined) {
                this.dataForm[key] = data.data[key]
              }
            }
          }
        }).catch((err) => {
          console.log(err)
        })
      } else {
        this.dataForm.countUtilizationFlag = '20'
        this.dataForm.quickTestFlag = '20'
        this.dataForm.serioustraining = '20'
      }
    },
    addInit (onCourseId) {
      this.again()
      this.$request.get('/learning/courseinfo/getOne/' + onCourseId).then((res, total, code, data) => {
        for (let key in data.data) {
          if (this.dataForm.hasOwnProperty(key)) {
            if (data.data[key] !== null || data.data[key] !== undefined) {
              this.dataForm[key] = data.data[key]
            }
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 保存方法
    save () {
      console.log('value1')
      console.log(this.dataForm)
      this.dataForm.courseId = this.courseid
      this.$refs['dataForm'].validate(valid => {
        if(valid){
        }else{
          return false
        }
        if (this.dataForm.quickTestFlag != 10) {
          this.dataForm.intervalTime = ''
        }
      this.$request.put(`/learning/courseinfo/csrptUpdate`,
        this.dataForm
      ).then((res, total, code, data) => {
        if (data.code === 13000000) {
          this.$message({
            message: this.$t(data.msg),
            type: 'error',
            duration: 2000
          })
        } else if (data.code === 1) {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          this.sendSave()
        }
      }).catch(e => {
        console.log(e)
      })
    })
    },
    // 保存并下一步
    saveSend () {
      this.$refs['dataForm'].validate(valid => {
        if(valid){
        }else{
          return false
        }
       if (this.dataForm.quickTestFlag != 10) {
          this.dataForm.intervalTime = ''
        }
      this.dataForm.courseId = this.courseid
      this.$request.put(`/learning/courseinfo/csrptUpdate`,
        this.dataForm
      ).then((res, total, code, data) => {
        if (data.code === 13000000) {
          this.$message({
            message: this.$t(data.msg),
            type: 'error',
            duration: 2000
          })
        } else if (data.code === 1) {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          this.sendMsg()
        }
      }).catch(e => {
        console.log(e)
      })
      })
    },
    // 向父页面传递消息 跳转下一页面
    sendMsg () {
      this.toTop()
      // console.log(this.dataForm)
      this.$emit('onShowModer', 'csinvestsend')
    },
    // 向父页面传递消息 保存页面
    sendSave () {
      this.$emit('onShowModer', 'csinvestSave')
      this.tabRemove()
      this.$router.push({
        name: 'learning-course-courseinfo'
      })
    },
    // 点击导航跳转页面
    on_click (e) {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('onShowModer', e)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    // 取消按钮
    cancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabRemove()
      }).catch((err) => {
        console.log(err)
      })
  }
  }
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.el-row {
  margin-bottom: 20px;
}
.el-row a {
  cursor: pointer;
}
.tag-option {
  display: none !important;
}
</style>
